import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-10 w-auto" }) => (
  <img src="/img/afr-crest.svg" alt="" aria-hidden="true" className={className} />
);

export const Logo = ({ white = false, className = "h-10 w-auto md:h-12" }) => (
  <Link to="/" data-testid={white ? "footer-logo-link" : "header-logo-link"} className="block shrink-0" aria-label="America First Refining home">
    <img src={white ? "/img/afr-logo-white.svg" : "/img/afr-logo-horizontal.svg"} alt="America First Refining" className={`${className} transition-opacity duration-300 hover:opacity-85`} />
  </Link>
);

export const FlagRule = ({ className = "" }) => (
  <div aria-hidden="true" className={`h-[14px] w-full bg-[repeating-linear-gradient(180deg,#C8102E_0_2px,#ffffff_2px_4px)] ${className}`} />
);
